"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = joinUrl;
// A line break in the route fails the match, so the result is '/' and the request is refused, as with proper-url-join
const urlPattern = /^(\w+:\/\/[^/?]+)?((?:(?!\?).)*)(\?.*)?$/;
/**
 * Joins a base URL and a route with single slashes and no trailing slash.
 * Anything from the first `?` on is kept as it is.
 */
function joinUrl(baseUrl, route) {
    const [, origin = '', pathname = '', query = ''] = [baseUrl, route].filter(Boolean).join('/').match(urlPattern) ?? [];
    const path = pathname.split('/').filter(Boolean).join('/');
    return `${origin}${path ? `/${path}` : ''}${query}` || '/';
}
//# sourceMappingURL=joinUrl.js.map